'use client'

import mixpanel from 'mixpanel-browser'
import { useEffect } from 'react'

import { setMixpanelReady } from '@/lib/analytics'

export function MixpanelProvider() {
  useEffect(() => {
    const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
    if (!token) return

    mixpanel.init(token, {
      track_pageview: true,
      persistence: 'localStorage',
      record_sessions_percent: 100,
    })

    setMixpanelReady()
    mixpanel.start_session_recording()
  }, [])

  return null
}
